import React, { Component } from 'react'
import injectSheet from 'react-jss'
import styles from './comments.styles'
import ContentHolder from '../../../content-holder/content-holder'
import Paper from 'pobble-components/dist/paper'
import CommentsTable from './comments-table/comments-table.container'
import CommentsSkeleton from './comments-skeleton/comments-skeleton'

class Comments extends Component {
  componentDidMount() {
    this.props.onMount()
  }
  render() {
    const { pending, classes } = this.props
    return (
      <ContentHolder className={classes.contentHolder}>
        <Paper className={classes.paper}>
          {pending && <CommentsSkeleton />}
          {!pending && <CommentsTable />}
        </Paper>
      </ContentHolder>
    )
  }
}

export default injectSheet(styles)(Comments)
